<section class="change-password-modal" aria-label="Change password popup">
  <header class="change-password-modal__header" mat-dialog-title>
    <h2>Change Password</h2>
    <button type="button" mat-icon-button class="icon-close" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="change-password-modal__content">
    <p class="change-password-modal__description">Update your credentials to keep your account secure.</p>

    <form class="change-password-modal__form" [formGroup]="form" novalidate>
      <mat-form-field appearance="outline">
        <mat-label>Old password</mat-label>
        <input matInput [type]="showOldPassword() ? 'text' : 'password'" formControlName="old_password" placeholder="Enter old password" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showOldPassword() ? 'Hide old password' : 'Show old password'"
          (click)="togglePasswordVisibility('old')"
        >
          <mat-icon>{{ showOldPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (hasControlError('old_password', 'required')) {
          <mat-error>Old password is required.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>New password</mat-label>
        <input matInput [type]="showNewPassword() ? 'text' : 'password'" formControlName="new_password" placeholder="Enter new password" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showNewPassword() ? 'Hide new password' : 'Show new password'"
          (click)="togglePasswordVisibility('new')"
        >
          <mat-icon>{{ showNewPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (hasControlError('new_password', 'required')) {
          <mat-error>New password is required.</mat-error>
        }
        @if (hasControlError('new_password', 'minlength')) {
          <mat-error>New password must be at least 8 characters.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm password</mat-label>
        <input matInput [type]="showConfirmPassword() ? 'text' : 'password'" formControlName="confirm_password" placeholder="Re-enter new password" />
        <button
          type="button"
          mat-icon-button
          matSuffix
          [attr.aria-label]="showConfirmPassword() ? 'Hide confirm password' : 'Show confirm password'"
          (click)="togglePasswordVisibility('confirm')"
        >
          <mat-icon>{{ showConfirmPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (hasControlError('confirm_password', 'required')) {
          <mat-error>Confirm password is required.</mat-error>
        }
        @if (hasPasswordMismatch()) {
          <mat-error>New password and confirm password must match.</mat-error>
        }
      </mat-form-field>
      @if(validationError()){
            <app-validation-error [errors]="validationError()"></app-validation-error>
            }
    </form>
  </div>

  <footer class="change-password-modal__actions" mat-dialog-actions align="end">
    <button type="button" mat-stroked-button color="primary" (click)="close()">Cancel</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">Update password</button>
  </footer>
</section>
